import { FC } from 'react';
import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { useChatbotAssistant } from '../../provider/chatbot-assistant.provider';

export const AssistantStatusBadge: FC<{ size?: number }> = ({ size = 32 }) => {
  const { isSending } = useChatbotAssistant();
  return (
    <div css={[styles.badgeContainer, styles.gradientBG, { width: size, height: size }]}>
      <Icon name={isSending ? 'assistant-busy' : 'assistant-idle'} color='white' />
    </div>
  );
};

export const AssistantCollapseBadge: FC<{ size?: number }> = ({ size = 32 }) => {
  return (
    <div css={[styles.badgeContainer, styles.neutralBorder, { width: size, height: size }]}>
      <Icon name='collapse' css={styles.collapseIcon} />
    </div>
  );
};

const styles = {
  badgeContainer: css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border-radius: ${theme.borderRadius.medium};
    padding: ${theme.spacing(0.5)};
  `,
  gradientBG: css`
    background: linear-gradient(
      45.06deg,
      #ff7301 2.26%,
      ${theme.colors.secondary.eggplant50} 50%,
      ${theme.colors.secondary.seaweed50} 97.74%
    );
  `,
  neutralBorder: css`
    border: 1.5px solid ${theme.colors.neutral30};
  `,
  image: css`
    width: 100%;
    height: 100%;
    transform: rotate(15deg);
  `,
  collapseIcon: css`
    color: ${theme.colors.neutral30};
  `,
};
